/**
 * @Author: wangping 1683997498@qq.com
 * @Date: 2024-04-06 09:57:28
 * @LastEditors: wangping 1683997498@qq.com
 * @LastEditTime: 2024-04-06 10:04:03
 * @FilePath: \twzc005-1\src\utils\index.js
 * @Description: 
 * @
 * @Copyright (c) 2024 by 广东天网智城科技有限公司, 保留所有权利。 
 */

/******* 
 * @description: 判断当前设备是移动端还是 PC 端
 * @return {*} ture:PC , false:mobile
 */
export function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}